import { useEffect, useRef, useState } from "react";

export const useUserMenu = () => {
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [isSettingsModalOpen, setIsSettingsModalOpen] = useState(false);
  const userMenuRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (!userMenuRef.current || userMenuRef.current.contains(event.target)) {
        return;
      }
      setIsUserMenuOpen(false);
    };

    const handleEscapeClose = (event) => {
      if (event.key === "Escape") {
        setIsUserMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    document.addEventListener("keydown", handleEscapeClose);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("keydown", handleEscapeClose);
    };
  }, []);

  const openSettingsPanel = () => {
    setIsUserMenuOpen(false);
    setIsSettingsModalOpen(true);
  };

  const closeSettingsPanel = () => {
    setIsSettingsModalOpen(false);
  };

  return {
    isUserMenuOpen,
    setIsUserMenuOpen,
    userMenuRef,
    isSettingsModalOpen,
    openSettingsPanel,
    closeSettingsPanel,
  };
};
